import React, { lazy, Suspense, useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Cookies from 'js-cookie'
import SlotSettings from "./Pages/Admin/EditPages/slotsettings";
import ManageHolidays from "./Pages/Admin/manageholidays";
import BaseUrl from "./Api/baseurl";
import UserProfile from "./Pages/userprofile";
import EditUserProfile from "./Pages/edituserprofile";
import UserChangePassword from "./Pages/userchangepassword";
const Home = lazy(() => import("./Pages/home"));
const About = lazy(() => import("./Pages/about"));
const Contact = lazy(() => import("./Pages/contact"));
const Services = lazy(() => import("./Pages/services"));
const Blog = lazy(() => import("./Pages/blog"));
const Pricing = lazy(() => import("./Pages/pricing"));
const Ourteam = lazy(() => import("./Pages/ourteam"));
const ServiceDetail = lazy(() => import("./Pages/servicedetail"));
const BlogDetail = lazy(() => import("./Pages/blogdetail"));
const Login = lazy(() => import("./Pages/login"));
const Signup = lazy(() => import("./Pages/signup"));
const ForgotPassword = lazy(() => import("./Pages/forgotpassword"));
const Address = lazy(() => import("./Pages/Admin/Configurations/address"));
const LogoChange = lazy(() => import("./Pages/Admin/Configurations/logochange"));
const FaviconChange = lazy(() => import("./Pages/Admin/Configurations/faviconchange"));
const SocialMediaProfiles = lazy(() => import("./Pages/Admin/Configurations/socialmediaprofiles"));
const Timings = lazy(() => import("./Pages/Admin/Configurations/timings"));
const SloganText = lazy(() => import("./Pages/Admin/Configurations/slogantext"));

const ManageBlogs = lazy(() => import("./Pages/Admin/manageblogs"));
const Header = lazy(() => import("./Components/header"));
const Footer = lazy(() => import("./Components/footer"));
const AdminHeader = lazy(() => import("./Components/adminheader"));
const MyProfile = lazy(() => import("./Pages/Admin/myprofile"));
const ManageContact = lazy(() => import("./Pages/Admin/managecontact"));
const ManageLocation = lazy(() => import("./Pages/Admin/managelocations"));
const ManageServices = lazy(() => import("./Pages/Admin/manageservices"));
const ManageContent = lazy(() => import("./Pages/Admin/managecontent"));
const AddBlog = lazy(() => import("./Pages/Admin/AddPages/addblogs"));
const EditBlog = lazy(() => import("./Pages/Admin/EditPages/editblog"));
const AdminLogin = lazy(() => import("./Pages/Admin/adminlogin"));
const AddService = lazy(() => import("./Pages/Admin/AddPages/addservices"));
const EditService = lazy(() => import("./Pages/Admin/EditPages/editservice"));
const AdminPageHeader = lazy(() => import("./Components/adminpageheader"));
const EditContent = lazy(() => import("./Pages/Admin/EditPages/editcontent"));
const AddLocation = lazy(() => import("./Pages/Admin/AddPages/addlocation"));
const EditLocation = lazy(() => import("./Pages/Admin/EditPages/editlocation"));
const PrivacyPolicy = lazy(() => import("./Pages/privacypolicy"));
const TermsofService = lazy(() => import("./Pages/termsofservice"));
const ManagePricing = lazy(() => import("./Pages/Admin/managepricing"));
const AddPricing = lazy(() => import("./Pages/Admin/AddPages/addpricing"));
const EditPricing = lazy(() => import("./Pages/Admin/EditPages/editpricing"));
const ManageSubscriptions = lazy(() => import("./Pages/Admin/managesubscriptions"));
const EditProfile = lazy(() => import("./Pages/Admin/EditPages/editprofile"));
const AddSubscription = lazy(() => import("./Pages/Admin/AddPages/addsubscription"));
const SubscriptionOptions = lazy(() => import("./Pages/Admin/Configurations/subscriptionoptions"));
const EditSubscription = lazy(() => import("./Pages/Admin/EditPages/editsubscription"));
const ChangePassword = lazy(() => import("./Pages/Admin/changepassword"));
const ManageVendor = lazy(() => import("./Pages/Admin/managevendor"));
const AddVendor = lazy(() => import("./Pages/Admin/AddPages/addvendor"));
const EditVendor = lazy(() => import("./Pages/Admin/EditPages/editvendor"));
const ManageStaff = lazy(() => import("./Pages/Admin/managestaff"));
const AddStaff = lazy(() => import("./Pages/Admin/AddPages/addstaff"));
const EditStaff = lazy(() => import("./Pages/Admin/EditPages/editstaff"));
const BookBarber = lazy(() => import("./Pages/bookbarber"));
const BookSlot = lazy(() => import("./Pages/bookslot"));
const ManageGallery = lazy(() => import("./Pages/Admin/managegallery"));
const EditGallery = lazy(() => import("./Pages/Admin/EditPages/editgallery"));
const ManageSlots = lazy(() => import("./Pages/Admin/manageslots"));
const StaffLogin = lazy(() => import("./Pages/Staff/stafflogin"));
const VendorLogin = lazy(() => import("./Pages/Vendor/vendorlogin"));

const AppContent = () => {
  const location = useLocation();
  const [token, setToken] = useState();
  const [loading, setLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(!!Cookies.get('token'));
  useEffect(() => {
    const interval = setInterval(() => {
      const newToken = Cookies.get('token');
      setToken(newToken);
      setIsLoggedIn(!!newToken);
    }, 2000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const isSuperuser = Cookies.get('is_superuser') === 'true';
    const isStaff = Cookies.get('is_staff') === 'true';
    const isVendor = Cookies.get('is_vendor') === 'true';
    if (isSuperuser) {
      setBasePath("/admin");
      console.log("admin");

    } else if (isStaff && !isSuperuser) {
      setBasePath("/staff");
      console.log("staff");

    } else if (isVendor) {
      setBasePath("/vendor")
      console.log("vendor");

    }
  }, [token])

  const [basePath, setBasePath] = useState(null);
  const isAdminPath = location.pathname.startsWith("/admin");
  const isVendorPath = location.pathname.startsWith("/vendor");
  const isStaffPath = location.pathname.startsWith("/staff");
  const adminLogin = location.pathname.endsWith("/admin/login");
  const staffLogin = location.pathname.endsWith("/staff/login");
  const vendorLogin = location.pathname.endsWith("/vendor/login");

  return (
    <>
      {adminLogin ? (
        <Suspense fallback={""}>
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
          </Routes>
        </Suspense>
      ) : null}
      {staffLogin ? (
        <Suspense fallback={""}>
          <Routes>
            <Route path="/staff/login" element={<StaffLogin />} />
          </Routes>
        </Suspense>
      ) : null}
      {vendorLogin ? (
        <Suspense fallback={""}>
          <Routes>
            <Route path="/vendor/login" element={<VendorLogin />} />
          </Routes>
        </Suspense>
      ) : null}
      {!adminLogin && !vendorLogin && !staffLogin && (isAdminPath || isStaffPath || isVendorPath) ? (
        <div className="flex flex-col md:flex-row w-full">
          <AdminHeader />
          <div className="flex flex-col w-full">
            <AdminPageHeader />
            <Routes>
              <Route path={`/${basePath}/logochange`} element={<LogoChange />} />
              <Route path={`/${basePath}/faviconchange`} element={<FaviconChange />} />
              <Route path={`/${basePath}/address`} element={<Address />} />
              <Route path={`/${basePath}/socialmediaprofiles`} element={<SocialMediaProfiles />} />
              <Route path={`/${basePath}/timings`} element={<Timings />} />
              <Route path={`/${basePath}/slogantext`} element={<SloganText />} />
              <Route path={`/${basePath}/managesubscriptions/addsubscription/subscriptionoptions`} element={<SubscriptionOptions />} />

              <Route path={`/${basePath}/managevendor`} element={<ManageVendor />} />
              <Route path={`/${basePath}/managestaff`} element={<ManageStaff />} />
              <Route path={`/${basePath}/managecontact`} element={<ManageContact />} />
              <Route path={`/${basePath}/services`} element={<ManageServices />} />
              <Route path={`/${basePath}/managecontent`} element={<ManageContent />} />
              <Route path={`/${basePath}/blogs`} element={<ManageBlogs />} />
              <Route path={`/${basePath}/managelocation`} element={<ManageLocation />} />
              <Route path={`/${basePath}/managepricing`} element={<ManagePricing />} />
              <Route path={`/${basePath}/managesubscriptions`} element={<ManageSubscriptions />} />
              <Route path={`/${basePath}/myprofile`} element={<MyProfile />} />
              <Route path={`/${basePath}/changepassword`} element={<ChangePassword />} />
              <Route path={`/${basePath}/managegallery`} element={<ManageGallery />} />
              <Route path={`/${basePath}/manageslots`} element={<ManageSlots />} />
              <Route path={`/${basePath}/manageholidays`} element={<ManageHolidays />} />

              {/* Add Pages */}
              <Route path={`/${basePath}/blogs/addblogs`} element={<AddBlog />} />
              <Route path={`/${basePath}/services/addservices`} element={<AddService />} />
              <Route path={`/${basePath}/managelocation/addlocation`} element={<AddLocation />} />
              <Route path={`/${basePath}/managepricing/addpricing`} element={<AddPricing />} />
              <Route path={`/${basePath}/managesubscriptions/addsubscription`} element={<AddSubscription />} />
              <Route path={`/${basePath}/managevendor/addvendor`} element={<AddVendor />} />
              <Route path={`/${basePath}/managestaff/addstaff`} element={<AddStaff />} />

              {/* Edit Pages */}
              <Route path={`/${basePath}/blogs/editblogs/:id`} element={<EditBlog />} />
              <Route path={`/${basePath}/services/editservices/:id`} element={<EditService />} />
              <Route path={`/${basePath}/managecontent/editcontent/:slug`} element={<EditContent />} />
              <Route path={`/${basePath}/managelocation/editlocation/:id`} element={<EditLocation />} />
              <Route path={`/${basePath}/managepricing/editpricing/:id`} element={<EditPricing />} />
              <Route path={`/${basePath}/myprofile/editprofile/:id`} element={<EditProfile />} />
              <Route path={`/${basePath}/managesubscriptions/editsubscription/:id`} element={<EditSubscription />} />
              <Route path={`/${basePath}/managevendor/editvendor/:id`} element={<EditVendor />} />
              <Route path={`/${basePath}/managestaff/editstaff/:id`} element={<EditStaff />} />
              <Route path={`/${basePath}/managegallery/editgallery`} element={<EditGallery />} />
              <Route path={`/${basePath}/manageslots/slotsettings`} element={<SlotSettings />} />
            </Routes>
          </div>
          {/* </Suspense> */}
        </div>
      ) : null}

      {!adminLogin && !vendorLogin && !staffLogin && !isAdminPath && !isStaffPath && !isVendorPath ? (
        <>
          <Header isLoggedIn={isLoggedIn} />
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/user/login" element={<Login setIsLoggedIn={setIsLoggedIn} />} />
              <Route path="/user/signup" element={<Signup />} />
              <Route path="/user/forgotpassword" element={<ForgotPassword />} />
              <Route path="/user/myprofile" element={<UserProfile setIsLoggedIn={setIsLoggedIn} />} />
              <Route path="/user/myprofile/edit" element={<EditUserProfile setIsLoggedIn={setIsLoggedIn} />} />
              <Route path="/user/changepassword" element={<UserChangePassword setIsLoggedIn={setIsLoggedIn} />} />
              <Route path="/bookbarber" element={<BookBarber />} />
              <Route path="/bookslot" element={<BookSlot />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/services" element={<Services />} />
              <Route path="/servicedetail" element={<ServiceDetail />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blogdetail" element={<BlogDetail />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/ourteam" element={<Ourteam />} />
              <Route path="/privacypolicy" element={<PrivacyPolicy />} />
              <Route path="/termsofservice" element={<TermsofService />} />
            </Routes>
          </Suspense>
          <Footer />
        </>
      ) : null}
    </>
  );
};

const App = () => {
  const [faviconUrl, setFaviconUrl] = useState('');
  useEffect(() => {
    const fetchFavicon = async () => {
      try {
        // Replace this URL with your actual Django API endpoint that returns the favicon URL
        const token = Cookies.get('token')
        console.log(token, "app");

        const response = await fetch(`${BaseUrl}/user/configurations/favicon/`, {
          // headers: {
          //   Authorization: `Token ${token}`,
          // },
          // withCredentials: true
        });
        const data = await response.json();

        if (data.favicon) {
          // If the favicon URL is found, update the state
          setFaviconUrl(data.favicon);
        } else {
          console.error('Favicon not found in the response.');
        }
      } catch (error) {
        console.error('Error fetching favicon:', error);
      }
    };

    fetchFavicon();
  }, []);
  useEffect(() => {
    if (faviconUrl) {
      const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
      link.type = 'image/x-icon';
      link.rel = 'icon';
      link.href = faviconUrl;
      document.head.appendChild(link);
    }
  }, [faviconUrl]);
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;